module.exports = __webpack_public_path__ + "static/img/92060B_C_4_5_20180322_fit.9f34a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92060B_C_4_5_20180322_fit.png
// module id = mTWp
// module chunks = 0